// src/components/About.tsx
import React from "react";
import Projects from './Projects';
import Pin from "./Pin";
import LinkedInIcon from "../components/icons/LinkedInIcon";

export default function About() {
  return (
    <>
    <section id="about">
      <div className="retro-header-wrapper">
        <h1 className="retro-header">JOAN WIT<span className="letter-flicker">H</span> THE CODE</h1>
      </div>
      <div className="relative retro-bulletin-wrapper flicker2 container mx-auto p-4">
        <div className="container mx-auto flex px-10 flex-col retro-bulletin">
          <div className="board-polaroid">
            <div className="polaroid retro flex-none">
              <img src="/omegarobot.png" alt="robot" />
              <p>Hi, I'm Joan.</p>
            </div>
          </div>
          
          <div className="board-certification">
            <div className="flex-none">
              <img src="certifications/az900.png" alt="Azure Fundamentals Certification" style={{ height:118 }}/>
            </div>
          </div>
  
          <div className="container-inner flex-none">
            <div className="sticky-container" style={{ transform: `rotate(${(Math.random()*6)-3}deg)` }}>
              <div className="sticky-outer">
                <div className="sticky">
                  <svg width="0" height="0">
                    <defs>
                      <clipPath id="stickyClip" clipPathUnits="objectBoundingBox">
                        <path
                          d="M 0 0 Q 0 0.69, 0.03 0.96 0.03 0.96, 1 0.96 Q 0.96 0.69, 0.96 0 0.96 0, 0 0"
                          strokeLinejoin="round"
                          strokeLinecap="square"
                        />  
                      </clipPath>
                    </defs>
                  </svg>
                  <div className="sticky-content">
                    Road-tripper and full-stack developer — I build apps, solve problems, and enjoy every step of bringing code to life.
                  </div>
                </div>
              </div>
            </div>
          </div>
           <div className="paper pink rotate-[3deg]">
    <div className="tape-section"></div>
    <p><u>skills</u>
    <br/>JavaScript, html, css, React,  SQL, WCAG Standards</p>
    <div className="tape-section"></div>
  </div>
        <nav
          aria-label="Social links"
          className="
          absolute top-4 right-4
          flex flex-col gap-3
          sm:top-4 sm:right-4
          max-sm:top-auto max-sm:top-4 max-sm:right-4"
        >
          <Pin
            href="https://www.linkedin.com/in/joanpetersohn"
            label="LinkedIn"
            className="rotate-[-2deg] hover:rotate-6
            "
          >
            <LinkedInIcon className="w-5 h-5 text-[#0A66C2]" />
          </Pin>

          {/*<Pin
          href="https://github.com/yourname"
          label="GitHub"
          className="rotate-[1deg]"
          >
          <GitHubIcon className="w-5 h-5 text-black" />
          </Pin>*/}
        </nav>
        
        </div>
        
      </div>
      <Projects />
      
    </section>
    <section
      aria-labelledby="behind-the-build-heading"
      className="mt-16 max-w-3xl mx-auto text-gray-300 retro-bulletin-wrapper"
    >
    <h2
      id="behind-the-build-heading"
      className="text-2xl font-semibold text-white mb-4"
    >
      Behind the Build
    </h2>

    <p className="mb-4">
      This portfolio is a standalone project, designed as an evolving space to explore
      front-end architecture, interactive design, and accessibility. It
      also serves as a personal playground for learning, experimentation, and
      staying current with evolving tools and technologies.
    </p>
    <p className="mb-4">
      Rather than a static showcase of finished work, it is a continual work-in-progress. 
      It is meant to reflect how I approach development, from idea to execution. 
      Some projects are presented "in progress" to highlight experimentation,
      iteration, and decision-making as they happen, not just polished outcomes.
    </p>
    <p className="mb-4">
      <b>Joan With the Code</b> uses:
    </p>

    <ul className="list-disc list-inside space-y-2">
      <li>React + TypeScript, React Router, styled with Tailwind CSS, ESLint</li>
      <li>Semantic HTML and ARIA landmarks for accessibility</li>
      <li>Responsive layouts designed for clarity across screen sizes</li>
    </ul>
  </section>
  </>
  );
}
